var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Create Run Sheet")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select SR")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.DeliveryUserList,
      "selected-option": _vm.DeliveryUserObj,
      "name": "ddlMisrouteReason",
      "placeholder": "Select Delivery User"
    },
    on: {
      "select": _vm.selectDeliveryUser
    },
    model: {
      value: (_vm.ddlMisrouteReason),
      callback: function($$v) {
        _vm.ddlMisrouteReason = $$v
      },
      expression: "ddlMisrouteReason"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 mr-2"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.ddlMisrouteReason == false
    },
    on: {
      "click": function($event) {
        return _vm.clearSR()
      }
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.allocation()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ddlMisrouteReason),
      expression: "ddlMisrouteReason"
    }],
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Allocation")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-3"
  }, [_c('label', [_vm._v("Job Type ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.jobTypeList,
      "selected-option": _vm.JobTypeObj,
      "name": "jobType",
      "placeholder": "Select Delivery User"
    },
    on: {
      "select": _vm.selectJobType
    },
    model: {
      value: (_vm.jobType),
      callback: function($$v) {
        _vm.jobType = $$v
      },
      expression: "jobType"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('jobType')),
      expression: "errors.has('jobType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('jobType')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-8 mt-2"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipment No")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtShipment),
      expression: "txtShipment"
    }],
    ref: "txtShipment",
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": _vm.jobType == 'RVP',
      "type": "text",
      "placeholder": "Enter / Scan Shipment No",
      "autocomplete": "off",
      "name": "txtShipment"
    },
    domProps: {
      "value": (_vm.txtShipment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtShipment = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errShipmentNo),
      expression: "errShipmentNo"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errShipmentNo))])], 1)], 1), _vm._v(" "), _c('dummy-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flagShowEbnVehicleNo),
      expression: "flagShowEbnVehicleNo"
    }],
    ref: "dummyShipInputBox",
    staticClass: "col-md-8 mt-4",
    attrs: {
      "isDummyInput": _vm.isShowDummyInput,
      "duration": _vm.dummyInputTimeout,
      "styleData": _vm.styleData
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flagShowEbnVehicleNo),
      expression: "flagShowEbnVehicleNo"
    }],
    staticClass: "col-md-6 mt-2"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Ebn Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ebnVehicleNo),
      expression: "ebnVehicleNo"
    }],
    ref: "ebnVehicleNo",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Vehicle No",
      "name": "ebnVehicleNo"
    },
    domProps: {
      "value": (_vm.ebnVehicleNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ebnVehicleNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errEbnVehicleNo),
      expression: "errEbnVehicleNo"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errEbnVehicleNo))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "11px",
      "color": "#7d7878",
      "font-weight": "700"
    }
  }, [_vm._v("(eg: MH 12 HA 5678 / DL 01 L HA 5678)")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 mr-2"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success mt-2 mr-2",
    attrs: {
      "type": "submit",
      "disabled": !_vm.flagAllocation
    }
  }, [_vm._v(" " + _vm._s(_vm.ButtonLabelChange))])], 1)], 1)], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isAllocating,
      "text": "Please wait Shipment Allocation is being processing..."
    },
    on: {
      "update:active": function($event) {
        _vm.isAllocating = $event
      }
    }
  }), _vm._v(" "), _c('dummy-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.flagShowEbnVehicleNo),
      expression: "!flagShowEbnVehicleNo"
    }],
    ref: "dummyShipInputBox2",
    staticClass: "col-md-8 mt-4",
    attrs: {
      "isDummyInput": _vm.isShowDummyInput,
      "duration": _vm.dummyInputTimeout,
      "styleData": _vm.styleData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [(_vm.jobType != 'RVP') ? [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDown,
      "dismissible": "",
      "fade": "",
      "variant": "danger"
    },
    on: {
      "dismiss-count-down": _vm.countDownChanged
    }
  }, [_vm._v(_vm._s(_vm.allocationErrorMsg) + " "), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.allocationMsgprexo)), (_vm.flagShowPreviousShipment) ? _c('i', {
    staticStyle: {
      "color": "blue",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.ShowShipments
    }
  }, [_c('br'), _vm._v(" Click here to view pending shipments")]) : _vm._e()]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDownSuccess,
      "dismissible": "",
      "fade": "",
      "variant": "success"
    },
    on: {
      "dismiss-count-down": _vm.countDownChangedSuccess
    }
  }, [_vm._v(_vm._s(_vm.allocationSuccessMsg)), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.allocationMsgprexo))])], 1)] : [(_vm.errorRvpAllocation || _vm.successRvpAllocation) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.errorRvpAllocation) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._l((_vm.errorRvpAllocationErrorArrobj), function(singleRvpError) {
    return [_c('span', [_vm._v(_vm._s(singleRvpError.shippingId) + " :- " + _vm._s(singleRvpError.message))]), _c('br'), _vm._v(" "), (singleRvpError.prexoShipment) ? _c('span', [_vm._v(_vm._s(_vm.rvpPrexoShipMsg) + " " + _vm._s(singleRvpError.prexoShipment))]) : _vm._e(), _c('br')]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.successRvpAllocation) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n                                     " + _vm._s(_vm.successRvpAllocation) + " "), _c('br'), _vm._v(" "), (_vm.rvpPrexoShipmentList.length == 1) ? _c('span', [_vm._v("\n                                      " + _vm._s(_vm.rvpPrexoShipMsg) + " " + _vm._s(_vm.rvpPrexoShipmentList) + "\n                                    ")]) : _vm._e(), _vm._v(" "), (_vm.rvpPrexoShipmentList.length > 1) ? _c('span', [_vm._v("\n                                      " + _vm._s(_vm.rvpPrexoShipMsgBulk) + " " + _vm._s(_vm.rvpPrexoShipmentList) + "\n                                    ")]) : _vm._e()]) : _vm._e()]) : _vm._e()]], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select Web/Mobile")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [(_vm.jobType === 'RVP') ? _c('input', {
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": "",
      "type": "text",
      "placeholder": "From Mobile",
      "autocomplete": "off",
      "name": "fromMobile"
    }
  }) : _c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.fromList,
      "selected-option": _vm.fromItemObj,
      "name": "from",
      "placeholder": "Select From"
    },
    on: {
      "select": _vm.selectFrom
    },
    model: {
      value: (_vm.FromId),
      callback: function($$v) {
        _vm.FromId = $$v
      },
      expression: "FromId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No. :")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtVehicleNo),
      expression: "txtVehicleNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$/
      }),
      expression: "{ required: true, regex: /^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$/ }"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('txtVehicleNo')
    },
    attrs: {
      "id": "txtVehicleNo",
      "type": "text",
      "name": "txtVehicleNo",
      "placeholder": "Enter Vehicle No",
      "minlength": 7,
      "maxlength": 15
    },
    domProps: {
      "value": (_vm.txtVehicleNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtVehicleNo = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "11px",
      "color": "#7d7878",
      "font-weight": "700"
    }
  }, [_vm._v("(eg: MH 12 HA 5678 / DL 01 L HA 5678)")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('txtVehicleNo')),
      expression: "errors.has('txtVehicleNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please enter Vehicle No.! ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmAllocation()
      }
    }
  }, [_vm._v("Confirm Allocation")])], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isConfirmLoad,
      "text": "Please wait confirm Allocation is being processing..."
    },
    on: {
      "update:active": function($event) {
        _vm.isConfirmLoad = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('pending-Pods', {
    attrs: {
      "isPendingPodsLoader": _vm.isPodsLoader,
      "IsPaperlessFlyerbarcode": _vm.IsPaperlessFlyerbarcode,
      "showShipmentList": _vm.showShipmentList
    },
    model: {
      value: (_vm.showShipmentModel),
      callback: function($$v) {
        _vm.showShipmentModel = $$v
      },
      expression: "showShipmentModel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 allocate-tabs"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "enlarge-css1"
  }, [(_vm.jobType != 'RVP') ? _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.viewFullScreenModel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt",
    attrs: {
      "title": "View full screen"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 tabs-active"
  }, [_c('b-tabs', {
    staticClass: "tabs-active-style",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Pending For Allocation",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.reloadPendingShipmentList()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.reloadPendingShipmentList('reload')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this pending shipment list"
    }
  })]), _vm._v("  \n                            "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.PendingForAllocationShipmentListcnt) + " ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31",
      "float": "right",
      "margin-bottom": "5px"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentKeySearchById),
      expression: "shipmentKeySearchById"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('shipmentKeySearchById')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search by shippingid",
      "name": "shipmentKeySearchById"
    },
    domProps: {
      "value": (_vm.shipmentKeySearchById)
    },
    on: {
      "keydown": _vm.searchAllAllocatedShipments,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentKeySearchById = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.loadPendingAllocationShipments()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }, [_vm._v(" Search ")])])], 1)], 1)], 1), _vm._v("  \n                              "), _c('Pending-for-Allocation-shipment', {
    ref: "PendingForAllocationShipments",
    attrs: {
      "isPendingAllocationShipmentListLoader": _vm.isPendingAllocationShipmentListLoader,
      "PendingForAllocationShipmentList": _vm.PendingForAllocationShipmentList,
      "JobType": _vm.jobType,
      "pageCount": _vm.PendingPageCount
    },
    on: {
      "getSelectedShipments": _vm.getSelectedShipments,
      "getPaginationDataChild": _vm.getPaginationData
    }
  })], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Allocated Shipments",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.reloadAllocatedShipmentList()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.reloadAllocatedShipmentList('reload')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this pending shipment list"
    }
  })]), _vm._v("  \n                            "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    }
  }, [_vm._v("Count - " + _vm._s(_vm.totalAllocatedShipmentcnt) + " ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31",
      "float": "right",
      "margin-bottom": "5px"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentKeySearchByIdAllocated),
      expression: "shipmentKeySearchByIdAllocated"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('shipmentKeySearchByIdAllocated')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search by shippingid",
      "name": "shipmentKeySearchByIdAllocated"
    },
    domProps: {
      "value": (_vm.shipmentKeySearchByIdAllocated)
    },
    on: {
      "keydown": _vm.searchAllAllocatedShipments,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentKeySearchByIdAllocated = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.loadAllocatedShipments()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }, [_vm._v(" Search ")])])], 1)], 1)], 1), _vm._v("  \n                            "), _c('Allocated-shipment', {
    attrs: {
      "isHandoverShipmentListLoader": _vm.isHandoverShipmentListLoader,
      "HandoverShipmentList": _vm.HandoverShipmentList,
      "pageCount1": _vm.AllocatedPageCount
    },
    on: {
      "getHandoverPaginationDataChild": _vm.getAllocatedPaginationData
    }
  })], 1)])], 1)], 1)])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.closeCloseTripModel = false
      }
    },
    model: {
      value: (_vm.closeTripModel),
      callback: function($$v) {
        _vm.closeTripModel = $$v
      },
      expression: "closeTripModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.ActiveTabIndex == 0 ? 'Pending For Allocation' : 'Allocated Shipments'))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeCloseTripModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [(_vm.ActiveTabIndex == 0) ? _c('Pending-for-Allocation-shipment', {
    ref: "PendingForAllocationShipments",
    attrs: {
      "isPendingAllocationShipmentListLoader": _vm.isPendingAllocationShipmentListLoader,
      "PendingForAllocationShipmentList": _vm.PendingForAllocationShipmentList,
      "JobType": _vm.jobType,
      "getSelectedShipments": _vm.getSelectedShipments,
      "pageCount": _vm.PendingPageCount
    },
    on: {
      "getPaginationDataChild": _vm.getPaginationData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ActiveTabIndex == 1) ? _c('Allocated-shipment', {
    attrs: {
      "isHandoverShipmentListLoader": _vm.isHandoverShipmentListLoader,
      "HandoverShipmentList": _vm.HandoverShipmentList,
      "pageCount1": _vm.AllocatedPageCount
    },
    on: {
      "getHandoverPaginationDataChild": _vm.getAllocatedPaginationData
    }
  }) : _vm._e()], 1)])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "RVP Allocated Shipment",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    on: {
      "hidden": _vm.closeRvpSuggestShipmentsModel
    },
    model: {
      value: (_vm.morePendingRVPShipmentsModel),
      callback: function($$v) {
        _vm.morePendingRVPShipmentsModel = $$v
      },
      expression: "morePendingRVPShipmentsModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("RVP pending for allocation shipment")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeRvpSuggestShipmentsModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [(_vm.morePendingRVPShipmentsModel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', [_c('legend', [_vm._v("List")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', [_vm._v("Below Shipments are from same customer, Please Allocate them to same SR. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.MergeSameCustomerSelectionShipment()
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeRvpSuggestShipmentsModel()
      }
    }
  }, [_vm._v(" Cancel")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.loadMoreSameCustomerShipment,
      "text": "Please wait shipments is handover to agent in processing..."
    },
    on: {
      "update:active": function($event) {
        _vm.loadMoreSameCustomerShipment = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "b-table table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sAllMoreShip),
      expression: "sAllMoreShip"
    }],
    attrs: {
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.sAllMoreShip) ? _vm._i(_vm.sAllMoreShip, "") > -1 : (_vm.sAllMoreShip)
    },
    on: {
      "click": function($event) {
        return _vm.selectAllMoreRVPShipments($event)
      },
      "change": function($event) {
        var $$a = _vm.sAllMoreShip,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sAllMoreShip = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sAllMoreShip = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sAllMoreShip = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Pending Days")]), _vm._v(" "), _c('th', [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', [_vm._v("Handover Date")]), _vm._v(" "), _c('th', [_vm._v("Courier Company Name")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [(_vm.suggestRVPArrayList.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._l((_vm.suggestRVPArrayList), function(row, index) {
    return _c('tr', {
      key: index,
      attrs: {
        "id": 'rvpTrMr' + row.shippingid
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.pendingForMoreAllocationData),
        expression: "pendingForMoreAllocationData"
      }],
      staticStyle: {
        "font-size": "0.8em"
      },
      attrs: {
        "type": "checkbox",
        "name": "pendingForMoreAllocationData"
      },
      domProps: {
        "value": row.shippingid,
        "checked": Array.isArray(_vm.pendingForMoreAllocationData) ? _vm._i(_vm.pendingForMoreAllocationData, row.shippingid) > -1 : (_vm.pendingForMoreAllocationData)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.pendingForMoreAllocationData,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row.shippingid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.pendingForMoreAllocationData = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.pendingForMoreAllocationData = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.pendingForMoreAllocationData = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.pendingdays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.shipmenttype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.handoverdate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.couriercompanyname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.status))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "id": 'CIMr' + row.ShippingId
      },
      domProps: {
        "value": row.ClientId
      }
    })])
  })], 2)])])], 1)])])], 1)])]) : _vm._e()])])])])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-773fd49e","hasScoped":false}!./src/views/components/AllocateHandoverShipment/AllocateHandoverShipment.component.html
// module id = 1113
// module chunks = 1